import iconCard from "../resources/icons/Icon-placeholder.png";

// Under navbar component

export const UNDER_NAVBAR_COMPONENT_COLOR_TITLE = "Connecting ";
export const UNDER_NAVBAR_COMPONENT_TITLE = "in construction";
export const UNDER_NAVBAR_COMPONENT_TEXT =
  "Connecting project management for construction companies, assignors and supervisors.";

//Icon Card Component

export const ICON_CARD_SECTION_TITLE =
  "Essential features for starting & managing your construction development";

export const ICON_CARD = [
  {
    src: iconCard,
    title: "Connecting you with partners",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
  },
  {
    src: iconCard,
    title: "Connecting you with partners",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
  },
  {
    src: iconCard,
    title: "Connecting you with partners",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
  }
];

//Number Card Component

export const NUMBER_CARD_SECTION_TITLE = "Simplifying construction development";

export const NUMBER_CARD_SECTION_TEXT =
  " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed doeiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt utlabore et dolore magna aliqua.";

export const NUMBER_CARD = [
  {
    number: "1",
    title: "Save Time",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
  },
  {
    number: "2",
    title: "Save Time",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
  },
  {
    number: "3",
    title: "Save Time",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
  }
];
